var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "172px",
    height: "52px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfaf9",
    d: "M -0.5,-0.5 C 56.8333,-0.5 114.167,-0.5 171.5,-0.5C 171.5,16.8333 171.5,34.1667 171.5,51.5C 114.167,51.5 56.8333,51.5 -0.5,51.5C -0.5,34.1667 -0.5,16.8333 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdc9aa",
    d: "M 18.5,1.5 C 24.6446,0.509836 30.9779,0.176503 37.5,0.5C 37.8214,6.02621 37.4881,11.3595 36.5,16.5C 36.5,11.5 36.5,6.5 36.5,1.5C 30.5,1.5 24.5,1.5 18.5,1.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ff783b",
    d: "M 18.5,1.5 C 24.5,1.5 30.5,1.5 36.5,1.5C 36.5,6.5 36.5,11.5 36.5,16.5C 33.8991,19.6043 31.0657,22.6043 28,25.5C 25.3176,22.6503 22.4843,19.9836 19.5,17.5C 16.7639,19.5693 14.4305,21.9026 12.5,24.5C 12.5,27.5 12.5,30.5 12.5,33.5C 9.83333,33.5 7.16667,33.5 4.5,33.5C 4.5,27.5 4.5,21.5 4.5,15.5C 9.16667,15.5 13.8333,15.5 18.5,15.5C 18.5,10.8333 18.5,6.16667 18.5,1.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffa97c",
    d: "M 160.5,8.5 C 159.833,8.5 159.5,8.83333 159.5,9.5C 150.585,2.96449 141.585,2.96449 132.5,9.5C 132.5,9.16667 132.5,8.83333 132.5,8.5C 138.854,2.62086 146.188,1.12086 154.5,4C 157.106,4.79181 159.106,6.29181 160.5,8.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fe9059",
    d: "M 86.5,1.5 C 91.5111,1.33407 96.5111,1.50074 101.5,2C 101.957,2.41395 102.291,2.91395 102.5,3.5C 100.086,7.91179 96.4198,9.74512 91.5,9C 94.9518,8.10829 97.9518,6.44162 100.5,4C 92.8147,3.40313 85.148,3.5698 77.5,4.5C 77.8325,18.1829 77.4992,31.8496 76.5,45.5C 75.5008,32.1833 75.1675,18.85 75.5,5.5C 69.2919,6.40272 63.4585,8.40272 58,11.5C 57.3123,10.6683 57.479,10.0016 58.5,9.5C 60.1667,8.66667 61.8333,7.83333 63.5,7C 71.2379,4.94114 78.9045,3.1078 86.5,1.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ff8146",
    d: "M 132.5,8.5 C 132.5,8.83333 132.5,9.16667 132.5,9.5C 128.74,11.9301 126.073,15.2634 124.5,19.5C 123.432,17.8125 123.599,16.1459 125,14.5C 127.106,11.8823 129.606,9.88229 132.5,8.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ff9a42",
    d: "M 37.5,34.5 C 37.1667,34.5 36.8333,34.5 36.5,34.5C 35.1667,35.8333 33.8333,35.8333 32.5,34.5C 37.7751,27.5561 43.7751,21.2228 50.5,15.5C 51.4963,21.7985 51.8297,28.1318 51.5,34.5C 46.8333,34.5 42.1667,34.5 37.5,34.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ff9b69",
    d: "M 112.5,27.5 C 119.858,29.5559 120.025,31.8892 113,34.5C 109.88,32.5327 109.713,30.1993 112.5,27.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ff7c3f",
    d: "M 160.5,8.5 C 162.368,15.0519 160.368,20.2186 154.5,24C 149.903,27.1233 145.237,29.9567 140.5,32.5C 139.51,38.31 139.177,44.31 139.5,50.5C 139.029,45.0068 138.029,39.5068 136.5,34C 138.046,27.822 139.046,21.6553 139.5,15.5C 139.173,20.544 139.506,25.544 140.5,30.5C 141.107,30.3764 141.44,30.0431 141.5,29.5C 148.981,26.8482 154.814,22.1816 159,15.5C 159.495,13.5273 159.662,11.5273 159.5,9.5C 159.5,8.83333 159.833,8.5 160.5,8.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#febf9b",
    d: "M 139.5,15.5 C 140.167,20.1667 140.833,24.8333 141.5,29.5C 141.44,30.0431 141.107,30.3764 140.5,30.5C 139.506,25.544 139.173,20.544 139.5,15.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ff9a67",
    d: "M 154.5,27.5 C 155.441,30.1251 156.607,30.1251 158,27.5C 158.353,28.6716 158.187,29.8382 157.5,31C 158.648,32.726 159.815,32.5593 161,30.5C 161.251,32.6032 160.251,33.9365 158,34.5C 156.5,34 155,33.5 153.5,33C 154.406,31.3005 154.739,29.4672 154.5,27.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffae83",
    d: "M 140.5,32.5 C 140.5,33.5 140.5,34.5 140.5,35.5C 146.905,36.2142 153.239,37.3809 159.5,39C 153.34,39.4623 147.34,38.629 141.5,36.5C 140.833,41.3167 140.166,45.9834 139.5,50.5C 139.177,44.31 139.51,38.31 140.5,32.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ff893e",
    d: "M 12.5,24.5 C 17.4797,29.1449 22.4797,33.8116 27.5,38.5C 29.1856,37.1431 30.8523,35.8098 32.5,34.5C 33.8333,35.8333 35.1667,35.8333 36.5,34.5C 36.5,39.1667 36.5,43.8333 36.5,48.5C 30.5,48.5 24.5,48.5 18.5,48.5C 18.5,43.8333 18.5,39.1667 18.5,34.5C 13.6367,34.8195 8.97005,34.4861 4.5,33.5C 7.16667,33.5 9.83333,33.5 12.5,33.5C 12.5,30.5 12.5,27.5 12.5,24.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ff8b54",
    d: "M 83.5,27.5 C 85.1667,27.5 86.8333,27.5 88.5,27.5C 88.17,33.7869 89.17,34.1203 91.5,28.5C 93.8056,28.0074 96.139,27.6741 98.5,27.5C 98.0048,33.1857 99.0048,33.6857 101.5,29C 103.473,28.5045 105.473,28.3379 107.5,28.5C 108.237,32.5294 107.737,36.5294 106,40.5C 103.977,45.2728 100.644,47.2728 96,46.5C 96.2581,40.856 99.0914,36.6893 104.5,34C 102.231,33.2419 100.064,33.4086 98,34.5C 96.8372,32.7148 96.1705,30.7148 96,28.5C 94.5771,30.3451 93.4104,32.3451 92.5,34.5C 91.8076,33.9747 91.3076,33.3081 91,32.5C 89.3333,33.8333 87.6667,33.8333 86,32.5C 83.7783,35.3033 81.9449,35.1366 80.5,32C 81.3146,30.3566 82.3146,28.8566 83.5,27.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdf3ec",
    d: "M 103.5,35.5 C 104.376,35.3691 105.043,35.7025 105.5,36.5C 104.806,39.0876 103.64,41.421 102,43.5C 100.556,45.1554 98.7224,45.822 96.5,45.5C 96.3505,44.448 96.5172,43.448 97,42.5C 99.3722,40.2968 101.539,37.9635 103.5,35.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee7d9",
    d: "M 102.5,29.5 C 106.102,29.678 106.102,30.678 102.5,32.5C 101.438,31.5754 101.438,30.5754 102.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdefe5",
    d: "M 84.5,28.5 C 85.8672,30.0927 85.5339,31.4261 83.5,32.5C 83.1667,32.1667 82.8333,31.8333 82.5,31.5C 83.1925,30.4822 83.8592,29.4822 84.5,28.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#febe93",
    d: "M 36.5,34.5 C 36.8333,34.5 37.1667,34.5 37.5,34.5C 37.5,39.5 37.5,44.5 37.5,49.5C 30.9779,49.8235 24.6446,49.4902 18.5,48.5C 24.5,48.5 30.5,48.5 36.5,48.5C 36.5,43.8333 36.5,39.1667 36.5,34.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d57e971a7568d3845ca95f276658335a.svg";
export { ForwardRef as ReactComponent };